import React from "react";
import { FileText } from "lucide-react";

/**
 * FileUpload Component
 * File upload input with display and attach button
 * 
 * @param {function} onChange - File change handler
 * @param {string} fileName - Current file name
 * @param {boolean} error - Error state
 * @param {string} errorMessage - Error message
 * @param {string} accept - Accepted file types
 */
const FileUpload = ({
  onChange,
  fileName,
  error = false,
  errorMessage,
  accept = ".jpg,.png,.pdf,.jpeg",
}) => {
  return (
    <div>
      {/* File Display */}
      {fileName && (
        <div className="flex items-center pl-1 mb-2">
          <FileText className="text-xs font-semibold" />
          <span className="text-[0.8rem] font-medium text-black ml-2">{fileName}</span>
        </div>
      )}
      {error && errorMessage && (
        <p className="m-0 text-[#EF5464] text-[0.60rem] py-[5px] whitespace-nowrap mb-2">
          {errorMessage}
        </p>
      )}

      {/* Attach Button */}
      <div className="relative overflow-hidden cursor-pointer font-roboto font-normal text-[0.668rem] sm:text-[0.8rem] leading-[0.688rem] text-[#2cc26a] text-right">
        Attach
        <input
          className="absolute h-full right-0 top-0 opacity-0 cursor-pointer"
          type="file"
          accept={accept}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default FileUpload;
